import { render, staticRenderFns } from "./addPossibleAnswer.vue?vue&type=template&id=5fcbabd5&scoped=true&"
import script from "./addPossibleAnswer.vue?vue&type=script&lang=js&"
export * from "./addPossibleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcbabd5",
  null
  
)

export default component.exports